import { Pipe, PipeTransform } from '@angular/core';

import { ibanFormatter } from './iban.formatter';

/**
 * @ngdoc pipe
 *
 * @deprecated - use `@ap/pipes` instead
 *
 * @name apIban
 *
 * @description
 *
 **/
@Pipe({ name: 'apIban', standalone: true })
export class ApIbanPipe implements PipeTransform {
    transform(iban: string): string {
        return ibanFormatter.formatDisplay(iban);
    }
}
